import { useState } from 'react';

export default function ResourceActionModal({title, item, onClose, onDeactivate, onReactivate}) {
    const [confirmingDeactivate, setConfirmingDeactivate] = useState(false);
    const [confirmingReactive, setConfirmingReactivate] = useState(false);
    const isActive = item.is_active;

    const handleConfirm = async() => {
        if (isActive) {
            await onDeactivate(item.id);
        } else {
            await onReactivate(item.id);
        }
        onClose();
    }

    return (
        <div>
            <h3 className='text-lg font-semibold'>
                {item.name}
            </h3>

            <p className='text-sm text-gray-600'>
                {isActive ? `${item.name} is currently active.` : `${item.name} is currently deactivated.`}
            </p>

            {!confirmingDeactivate && !confirmingReactive ? (
                <div className='flex justify-end gap-3'>
                    <button onClick={onClose} className='px-4 py-2 text-sm rounded border hover:bg-gray-200'>
                        cancel
                    </button>

                    {isActive ? (
                        <button onClick={() => setConfirmingDeactivate(true)} className='px-4 py-2 text-sm rounded bg-red-600 text-white hover:bg-red-700'>
                            deactivate
                        </button>
                    ) : (
                        <button onClick={() => setConfirmingReactivate(true)} className='px-4 py-2 text-sm rounded bg-docpgrPurple60 text-white hover:bg-docpgrPurple70'>
                            reactivate
                        </button>
                    )}
                </div>
            ) : (
                <div className='space-y-3'>
                    <p classname='text-sm text-red-600'>
                        are you sure you want to {isActive ? 'deactivate' : 'reactivate'} {item.name}?
                    </p>

                    <div className='flex justify-end gap-3'>
                        <button onClick={() => {setConfirmingDeactivate(false); setConfirmingReactivate(false);}} className='px-4 py-2 text-sm rounded border hover:bg-gray-200'>
                            cancel
                        </button>
                        <button onClick={handleConfirm} className={`px-4 py-2 text-sm rounded text-white ${isActive ? 'bg-red-600  hover:bg-red-700' : 'bg-docpgrPurple60 hover:bg-docpgrPurple70'}`}>
                            {isActive ? 'yes, deactivate' : 'yes, reactivate'}
                        </button>
                    </div>
                </div>
            )}

            

        </div>
    )
}